import { Fragment, useMemo, useState } from 'react';
import NavigationBar from '@components/common/navbar';
import ElixirTicker from '@components/common/elixir-ticker';
import CustomerWelcomeModal, { getElixirUrl } from '@components/common/customer-welcome-modal';
import { Outlet, useLocation } from 'react-router-dom';
import { CLIENT_ROUTES } from '@router/routes';
import { getPermissionFromLocalStorage } from '@helpers/utils';
import { USER_TYPES } from '@helpers/constants';

const POPUP_COOKIE = 'elixir_popup_dismissed';
const COOKIE_MAX_AGE = 100 * 365 * 24 * 3600;

function isPopupDismissed(): boolean {
  return document.cookie.split(';').some((c) => c.trim().startsWith(`${POPUP_COOKIE}=true`));
}

function markPopupDismissed(): void {
  document.cookie = `${POPUP_COOKIE}=true; max-age=${COOKIE_MAX_AGE}; path=/`;
}

function MainLayout() {
  const navItems = useMemo(
    () => [
      {
        to: `/${CLIENT_ROUTES.order}`,
        children: 'Orders'
      },
      {
        to: `/${CLIENT_ROUTES.supplier}`,
        children: 'Suppliers'
      },
      {
        to: `/${CLIENT_ROUTES.customer}`,
        children: 'Customers'
      },
      {
        to: `/${CLIENT_ROUTES.product}`,
        children: 'Products'
      },
      {
        to: `/${CLIENT_ROUTES.enquiry}`,
        children: 'Enquiry'
      },
      {
        to: `/${CLIENT_ROUTES.task}`,
        children: 'Tasks'
      },
      {
        to: `/${CLIENT_ROUTES.finance}`,
        children: 'Payables'
      },
      {
        to: `/${CLIENT_ROUTES.quoteGenerator}`,
        children: 'Quote'
      }
    ],
    []
  );

  const navItemsForCustomer = useMemo(
    () => [
      {
        to: `/${CLIENT_ROUTES.order}`,
        children: 'Orders'
      },
      {
        to: `/${CLIENT_ROUTES.enquiry}`,
        children: 'Enquiry'
      }
    ],
    []
  );

  const location = useLocation();
  const isExternalUser = getPermissionFromLocalStorage()?.user_type === USER_TYPES.customer;
  const [modalOpen, setModalOpen] = useState(isExternalUser && !isPopupDismissed());

  const elixirUrl = getElixirUrl(location.pathname, new URLSearchParams(location.search));

  const handleModalClose = () => {
    markPopupDismissed();
    setModalOpen(false);
  };

  return (
    <Fragment>
      <NavigationBar items={navItems} navItemsForCustomer={navItemsForCustomer} />
      {isExternalUser && <ElixirTicker />}
      {isExternalUser && (
        <CustomerWelcomeModal open={modalOpen} onClose={handleModalClose} ctaUrl={elixirUrl} />
      )}
      <Outlet />
    </Fragment>
  );
}
export default MainLayout;
